export const LAUNCH_SELECTION_TOUR = 'launch_selection_tour';
export const SHOW_SELECTION_SIDEBAR = 'show_selection_sidebar';
export const HIDE_SELECTION_SIDEBAR = 'hide_selection_sidebar';
export const SEARCH_RESULT_SUCCESS = 'search_result_success';
